import React from "react";
import { Upload, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface BrandImportUploadSectionProps {
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDownloadSample: () => void;
}

export const BrandImportUploadSection: React.FC<BrandImportUploadSectionProps> = ({
  fileInputRef,
  onFileChange,
  onDownloadSample,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Upload CSV File</h3>
        <Button variant="outline" size="sm" onClick={onDownloadSample}>
          <Download className="w-4 h-4 mr-2" />
          Download Sample CSV
        </Button>
      </div>

      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
        <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <div className="space-y-2">
          <p className="text-sm text-gray-600">
            Select a CSV file with brand data
          </p>
          <Input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={onFileChange}
            className="max-w-xs mx-auto"
          />
        </div>
      </div>

      {/* Instructions */}
      <div className="bg-blue-50 p-4 rounded-lg">
        <h4 className="font-medium text-blue-900 mb-2">CSV Format Requirements:</h4>
        <p className="text-sm text-blue-800 mb-2">
          Required columns: <code>name</code>
        </p>
        <p className="text-sm text-blue-800">
          Optional columns: <code>description</code>, <code>industry</code>,{" "}
          <code>website_url</code>, <code>logo_url</code>
        </p>
      </div>
    </div>
  );
};
